/* eslint-disable import/no-anonymous-default-export */
import { SET_PROMPTER_TEXT } from '../actionConstants';

export default (state = '', action) => {
  switch (action.type) {
    case SET_PROMPTER_TEXT:
      return action.payload;
    default:
      return state;
  }
};
